import React from 'react'

const Footer = () => {
    const year = new Date().getFullYear()

    return (
        <footer className="footerSection">
            <div className="footer" style={{
                marginTop: 'auto',
                borderTop: '1px solid rgba(0,0,0,0.06)',
                background: '#fff',
                padding: '14px 24px',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '4px',
            }}>
                <span style={{
                    fontSize: '12px',
                    color: '#f97316',
                    fontFamily: "'Sora', sans-serif",
                    fontWeight: 500,
                }}>
                    &copy; {year} Sat Kartar Life Limited.
                </span>
                <span style={{
                    fontSize: '12px',
                    color: '#999',
                    fontFamily: "'Sora', sans-serif",
                    fontWeight: 500,
                }}>
                    All Rights Reserved
                </span>
            </div>
        </footer>
    )
}

export default Footer
